export default "__VITE_ASSET__361ba588__"